import { Component, OnInit, Input } from "@angular/core";
import { NgClass } from "@angular/common";

import { BvLogoLoaderComponent } from "../../design-system/primitives/logo-loader.component";

const SIZE_PX = {
  small: 48,
  medium: 80,
  large: 128,
} as const;

@Component({
    selector: "app-loading-overlay",
    templateUrl: "./loading-overlay.component.html",
    styleUrls: ["./loading-overlay.component.css"],
    imports: [NgClass, BvLogoLoaderComponent]
})
export class LoadingOverlayComponent implements OnInit {
  // boolean | null so callers can bind nullable flags (e.g. sub_processing).
  @Input() isLoading: boolean | null = false;
  /** Explicit size override. When unset, fullscreen overlays use "large" and
      section overlays use "medium" so full-screen loaders stay consistent. */
  @Input() spinnerSize?: "small" | "medium" | "large";
  @Input() fullscreen = false;
  constructor() {}
  get logoPx(): number {
    const size = this.spinnerSize ?? (this.fullscreen ? "large" : "medium");
    return SIZE_PX[size];
  }
  ngOnInit(): void {}
}
